import React, { useState } from 'react';
import {
  Box, Checkbox, Container, Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Elements from '../../../Elements';
import { setDefaultLang } from '../../../../Utils/storages';

export default function Component({
  // subscribed: checked,
  classes,
}) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [langs] = useState([
    {
      label: 'English',
      lang: 'en',
    },
    {
      label: 'France',
      lang: 'fr',
    },
  ]);

  const changeLang = (newLang) => {
    i18n.changeLanguage(newLang);
    setDefaultLang(newLang);
  };

  return (
    <Elements.PageBase navigate={navigate}>
      <Box className={classes.root}>
        <Elements.Navigator title={t('lang.title')} />
        <Container>
          <Stack direction="column" spacing={3} mt={2}>
            {langs.map((lang) => (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                key={lang.lang}
                borderBottom="1px solid #eee"
                py={2}
                onClick={() => changeLang(lang.lang)}
              >
                <Box>
                  <Box fontWeight="600">{lang.label}</Box>
                </Box>
                <Box>
                  <Checkbox
                    sx={{ p: 0 }}
                    checked={i18n.language === lang.lang}
                  />
                </Box>
              </Box>
            ))}

          </Stack>
        </Container>
      </Box>

      <Elements.Footer />
    </Elements.PageBase>
  );
}
